import React from 'react';
import AdminSidebar from '../components/AdminSidebar';
import '../styles/admin.css';

const AdminMessages = () => {
  return (
    <div className="admin-container">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1 className="admin-header-title">💬 Мессеж Удирдах</h1>
        </div>

        <div className="admin-main">
          <div style={{ textAlign: 'center', padding: '40px', color: '#ddd' }}>
            <p style={{ fontSize: '18px', marginBottom: '15px' }}>⏳ Энэ хэсэг ирээдүйд хөгжүүлэх гэж байна</p>
            <p style={{ fontSize: '14px', color: '#999' }}>Мессеж удирдах функцийн хөгжүүлэлт эхэлнэ</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminMessages;

/*
// ORIGINAL CODE - COMMENTED OUT FOR FUTURE USE
import React, { useState, useEffect } from 'react';
import AdminSidebar from '../components/AdminSidebar';
import '../styles/admin.css';

const AdminMessages = () => {
  const [messages, setMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);

  useEffect(() => {
    // Mock data
    const mockMessages = [
      {
        id: 1,
        name: 'Батаа',
        email: 'bataa@example.com',
        subject: 'Бүтээгдэхүүний асуулга',
        message: 'Mining Drill-ын үнэ хэд байна?',
        date: '2024-04-05',
        status: 'Уншаагүй',
      },
      {
        id: 2,
        name: 'Сүхээ',
        email: 'sukhee@example.com',
        subject: 'Хүргүүлэлтийн асуулга',
        message: 'Ямар хүргүүлэлтийн сонголт байна?',
        date: '2024-04-04',
        status: 'Уншаагүй',
      },
      {
        id: 3,
        name: 'Энхцэцэг',
        email: 'enkhtsetseg@example.com',
        subject: 'Баталгаа',
        message: 'Цэ үнийн баталгаа хэр удаа?',
        date: '2024-04-03',
        status: 'Хариулагдсан',
      },
    ];
    setMessages(mockMessages);
  }, []);

  const handleMarkAsRead = (id) => {
    setMessages(messages.map((m) => (m.id === id ? { ...m, status: 'Уншаагдсан' } : m)));
  };

  const handleDeleteMessage = (id) => {
    if (window.confirm('Энэ мессежийг устгахдаа итгэлтэй байна уу?')) {
      setMessages(messages.filter((m) => m.id !== id));
    }
  };

  return (
    <div className="admin-container">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1 className="admin-header-title">💬 Холбоо Барих Мессеж</h1>
          <span style={{ color: '#ddd' }}>Нийт: {messages.length}</span>
        </div>

        <div className="admin-main">
          {messages.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#ddd' }}>
              <p>Мессеж олдсонгүй</p>
            </div>
          ) : (
            <>
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Нэр</th>
                    <th>Имэйл</th>
                    <th>Сэдэв</th>
                    <th>Огноо</th>
                    <th>Төлөв</th>
                    <th>Үйлдэл</th>
                  </tr>
                </thead>
                <tbody>
                  {messages.map((msg) => (
                    <tr key={msg.id} onClick={() => setSelectedMessage(msg)}>
                      <td>{msg.name}</td>
                      <td>{msg.email}</td>
                      <td>{msg.subject}</td>
                      <td>{msg.date}</td>
                      <td>
                        <span
                          style={{
                            padding: '5px 10px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontWeight: '600',
                            background: msg.status === 'Уншаагүй' ? 'rgba(244, 83, 37, 0.1)' : 'rgba(40, 167, 69, 0.1)',
                            color: msg.status === 'Уншаагүй' ? '#F45325' : '#28a745',
                          }}
                        >
                          {msg.status}
                        </span>
                      </td>
                      <td>
                        <div className="admin-btn-group">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleMarkAsRead(msg.id);
                            }}
                            className="admin-btn admin-btn-secondary"
                            style={{ fontSize: '12px', padding: '6px 12px' }}
                          >
                            ✓ Уншаасан
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteMessage(msg.id);
                            }}
                            className="admin-btn admin-btn-danger"
                            style={{ fontSize: '12px', padding: '6px 12px' }}
                          >
                            🗑️ Устгах
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {selectedMessage && (
                <div style={{ marginTop: '30px', padding: '20px', background: 'rgba(53, 51, 51, 0.5)', borderRadius: '8px' }}>
                  <h3 style={{ color: '#fff', marginBottom: '15px' }}>📨 Мессежийн дэлгэрэнгүй</h3>
                  <p><strong style={{ color: '#F45325' }}>Нэр:</strong> {selectedMessage.name}</p>
                  <p><strong style={{ color: '#F45325' }}>Имэйл:</strong> {selectedMessage.email}</p>
                  <p><strong style={{ color: '#F45325' }}>Сэдэв:</strong> {selectedMessage.subject}</p>
                  <p><strong style={{ color: '#F45325' }}>Мессеж:</strong></p>
                  <p style={{ background: 'rgba(0, 0, 0, 0.3)', padding: '10px', borderRadius: '4px', marginTop: '10px' }}>
                    {selectedMessage.message}
                  </p>
                  <button onClick={() => setSelectedMessage(null)} className="admin-btn admin-btn-secondary" style={{ marginTop: '15px' }}>
                    ❌ Хаах
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminMessages;
*/
